module.exports = __webpack_public_path__ + "img/unionpay.4f196077.svg";